import styled from 'styled-components'

const Container = styled.div`
 .header {
     button {
         background : transparent;
         position: absolute;
    right: 0;
    top: 10px;
     }
 }  

`
const TrackBox = styled.div`
    padding: 20px 16px;
  > p {
    display: flex;
    justify-content: space-between;
    color: #00b3ff;
    text-transform: uppercase;
    font-size: 12px;
        font-family: "latobold";

    > span {
      cursor: pointer;
    }
  }

`

const Body = styled.div``


export { Container, Body, TrackBox };